function Loop() {
    this.object = function (obj, callback) {
        var keys = Object.keys(obj);
        for (var i = 0; i < keys.length; i++) {
            (function (i) {
                callback(keys, i);
            })(i);
        }
    };

    this.array = function (array, callback, reverse) {
        if (reverse) {
            for (var i = array.length - 1; i > -1; i--) {
                (function (i) {
                    callback(array, i);
                })(i);
            }
        } else {
            for (var i = 0; i < array.length; i++) {
                (function (i) {
                    callback(array, i);
                })(i);
            }
        }
    };
}


function Personalisation() {
    var self = this;
    var loop = new Loop();

    this.text = document.querySelector('.js-personalisation-text');
    this.colour = document.querySelector('.js-personalisation-colour');
    this.label = document.querySelector('.js-personalisation-label');

    this.click = true;

    this.exists = function() {
        return this.text;
    }

    this.init = function() {
        this.textField = this.text.querySelector('input');
        this.colourField = this.colour.querySelectorAll('input');

        this.textField.addEventListener('keyup', this.check.bind(this));

        loop.array(this.colourField, function(array, i) {
            array[i].addEventListener('change', self.changeColour.bind(self));
        });
    }

    this.getFirstColour = function() {
        return this.colour.querySelector('input');
    }

    this.getActiveColour = function() {
        return this.colour.querySelector('input:checked');
    }

    this.getAllActiveColours = function() {
        return this.colour.querySelectorAll('input:checked');
    }

    this.check = function() {
        if (this.textField.value == '') {
            if (this.getActiveColour()) {
                this.deactivate();
            }
        } else if (!this.getActiveColour()) {
            this.activate();
        }
    }

    this.changeColour = function(e) {
        if (this.click) {
            if (e.target.checked) {
                var colours = this.getAllActiveColours();


                this.click = false;
                loop.array(colours, function(array, i) {
                    if (array[i].id != e.target.id) {
                        array[i].checked = null;
                        array[i].dispatchEvent(new CustomEvent('change'));
                    }
                });
                this.click = true;

                this.setlabel(e.target.parentNode.querySelector('.swatch__text').innerHTML);
            } else {
                this.setlabel('');
            }
        }
    }

    this.activate = function() {
        var colour = this.getFirstColour();

        this.text.classList.add('product-detail__personalisation--active');
        this.colour.classList.add('product-detail__personalisation--active');
        colour.checked = true;
        colour.dispatchEvent(new CustomEvent('change'));
    }

    this.deactivate = function() {
        var colour = this.getActiveColour();

        this.text.classList.remove('product-detail__personalisation--active');
        this.colour.classList.remove('product-detail__personalisation--active');
        colour.checked = null;
        colour.dispatchEvent(new CustomEvent('change'));
        this.setlabel('');
    }

    this.setlabel = function(html) {
        this.label.innerHTML = html;
    }
}


Soho.personalisation = new Personalisation();
if (Soho.personalisation.exists()) {
    Soho.personalisation.init();
}
